module.exports = __webpack_public_path__ + "img/empty.82ee6847.png";